import { useState } from 'react';
import {
  UserManagement,
  MunicipalityManagement,
  AnalyticsDashboard,
  PermitExtractionInput,
  SearchDataManagement,
} from '@/components/admin';

type AdminTab = 'dashboard' | 'users' | 'municipalities' | 'extraction' | 'search-data';

export default function AdminPage() {
  const [activeTab, setActiveTab] = useState<AdminTab>('dashboard');

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Admin Panel</h1>
        <p className="text-gray-600">
          Manage users, municipalities, and monitor system performance
        </p>
      </div>

      {/* Tab Navigation */}
      <div className="mb-6 border-b border-gray-200">
        <nav className="-mb-px flex space-x-8" aria-label="Tabs">
          <button
            onClick={() => setActiveTab('dashboard')}
            className={`
              whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors
              ${
                activeTab === 'dashboard'
                  ? 'border-purple-600 text-purple-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }
            `}
            aria-current={activeTab === 'dashboard' ? 'page' : undefined}
          >
            <div className="flex items-center gap-2">
              <span className="text-xl">📊</span>
              <span>Analytics Dashboard</span>
            </div>
          </button>

          <button
            onClick={() => setActiveTab('users')}
            className={`
              whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors
              ${
                activeTab === 'users'
                  ? 'border-purple-600 text-purple-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }
            `}
            aria-current={activeTab === 'users' ? 'page' : undefined}
          >
            <div className="flex items-center gap-2">
              <span className="text-xl">👥</span>
              <span>User Management</span>
            </div>
          </button>

          <button
            onClick={() => setActiveTab('municipalities')}
            className={`
              whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors
              ${
                activeTab === 'municipalities'
                  ? 'border-purple-600 text-purple-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }
            `}
            aria-current={activeTab === 'municipalities' ? 'page' : undefined}
          >
            <div className="flex items-center gap-2">
              <span className="text-xl">🏛️</span>
              <span>Municipality Data</span>
            </div>
          </button>

          <button
            onClick={() => setActiveTab('extraction')}
            className={`
              whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors
              ${
                activeTab === 'extraction'
                  ? 'border-purple-600 text-purple-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }
            `}
            aria-current={activeTab === 'extraction' ? 'page' : undefined}
          >
            <div className="flex items-center gap-2">
              <span className="text-xl">📝</span>
              <span>Extraction Input</span>
            </div>
          </button>

          <button
            onClick={() => setActiveTab('search-data')}
            className={`
              whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors
              ${
                activeTab === 'search-data'
                  ? 'border-purple-600 text-purple-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }
            `}
            aria-current={activeTab === 'search-data' ? 'page' : undefined}
          >
            <div className="flex items-center gap-2">
              <span className="text-xl">🔍</span>
              <span>Search Data</span>
            </div>
          </button>
        </nav>
      </div>

      {/* Tab Content */}
      <div className="mt-6">
        {activeTab === 'dashboard' && <AnalyticsDashboard />}
        {activeTab === 'users' && <UserManagement />}
        {activeTab === 'municipalities' && <MunicipalityManagement />}
        {activeTab === 'extraction' && <PermitExtractionInput />}
        {activeTab === 'search-data' && <SearchDataManagement />}
      </div>
    </div>
  );
}
